import { render, staticRenderFns } from "./ScoreGroup.vue?vue&type=template&id=7cdc9d9c&scoped=true"
import script from "./ScoreGroup.vue?vue&type=script&lang=js"
export * from "./ScoreGroup.vue?vue&type=script&lang=js"
import style0 from "./ScoreGroup.vue?vue&type=style&index=0&id=7cdc9d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdc9d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
